export const TRENT_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_property-inspect-23/artifacts/80gwbr4c_Trent.png";

export default function Logo({ size = 36, className = "", showSub = false }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <img
        src={TRENT_LOGO_URL}
        alt="Trent Property Management"
        style={{ height: size }}
        className="w-auto select-none"
      />
      {showSub && (
        <div className="hidden sm:block leading-tight">
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#6B7280]">
            Property Inspections · IE
          </div>
        </div>
      )}
    </div>
  );
}
